import { render, staticRenderFns } from "./ActivityLogs.vue?vue&type=template&id=6b107712&scoped=true&"
import script from "./ActivityLogs.vue?vue&type=script&lang=ts&"
export * from "./ActivityLogs.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityLogs.vue?vue&type=style&index=0&id=6b107712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b107712",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VTextField})
